var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.993 23.254c-.223 0-.423-.097-.561-.252l-.001-.001-11.5-13c-.113-.13-.182-.302-.182-.489 0-.414.336-.75.75-.75.219 0 .417.094.554.245l.001.001 10.938 12.365 10.938-12.365c.138-.16.342-.261.568-.261.414 0 .75.336.75.75 0 .195-.074.372-.196.505l.001-.001-11.5 13c-.138.155-.338.253-.562.253z"
  })));
};
export default SvgChevronDown;